import React, { useState, useEffect, useRef } from 'react';
import "./pgmdetailsthreewheeler.scss";
import Sidebar from "../Sidebar";
import { pgmdetailAction } from "../../actions/pgmlistAction";
import { useDispatch } from "react-redux";
import { useParams } from 'react-router-dom'
import { useNavigate } from "react-router-dom";
import { notify } from '../../services/notification';
import { decode } from "base-64";
import Header from "../../component/loaderComponent/Header/Header";
import Loader from "../../component/loaderComponent/loaderComponent/Loader";
import { Image_Url } from '../../constants/imageUrl/ImageUrl';
import { HiMenu, HiX } from "react-icons/hi";
import useMobileView from "../../constants/useMobileView";


function PgmDetailsThreeWheeler() {
  const [state, setDataState] = useState({
    pgmdetail: [],
    mobile_number: "",
    pincode: "",
    user_name: "",
    email: "",
    city: "",
    account_number: "",
    gst_number: "",
    district: "",
    state: "",
    is_approve: "",
    verification_type: "",
    verification_id: "",
    shop_name: "",
    pgm_status: "",
    profile: "",
    banner: '',
    doc_file: '',
    agency_code: '',
    refer_code: '',
    aps_code: '',
    aps_name: '',
    area_head_email: '',
    dealers: []

  });
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const { isSidebarOpen, toggleSidebar } = useMobileView();

  const dispatch = useDispatch();
  useEffect(() => {
    PgmDetailData();
  }, []);

  const { id } = useParams()
  const decodeid = decode(id)

  async function PgmDetailData() {
    let response = await dispatch(pgmdetailAction(decodeid));
    if (response == 200 || response != null) {
      setDataState({
        pgmdetail: response.data.data,
        mobile_number: response.data.data.mobile_number,
        pincode: response.data.data.pincode,
        account_number: response.data.data.account_number,
        gst_number: response?.data?.data?.user_document.map((item) => item?.meta_value),
        email: response.data.data.email,
        city: response.data.data.city,
        user_name: response.data.data.name,
        district: response.data.data.district,
        state: response.data.data.state,
        is_approve: response.data.data.is_approve,
        is_deleted: response.data.data.is_deleted,
        verification_type: response.data.data.doc_type,
        verification_id: response.data.data.doc_id,
        shop_name: response.data.data.garage_name,
        shop_location: response.data.data.location,
        pgm_status: response.data.data.pgm_status,
        profile: response.data.data.profile,
        banner: response.data.data.banner,
        doc_file: response.data.data.doc_file,
        agency_code: response.data.data.agency_code,
        refer_code: response.data.data.referred_by_refer_code,
        aps_code: response.data.data.aps_code,
        aps_name: response.data.data.aps_name,
        area_head_email: response.data.data.area_head_email,
        id: response.data.data.id,
        dealers: response?.data?.data?.dealers || [],
        location_link: response.data.data.location_link,
      });
    }
  }


  const onclose = () => {
    window.scroll(0, 0);
    navigate('/3w/pgmlist')
  }

  const [dimensions, setDimensions] = useState({ height: null, width: null });
  const [originalDimensions, setOriginalDimensions] = useState({ height: null, width: null });
  const imgRef = useRef(null);

  useEffect(() => {
    // Saving initial dimension of image
    if (imgRef.current) {
      const height = imgRef.current.clientHeight;
      const width = imgRef.current.clientWidth;

      setDimensions({ height, width });
      setOriginalDimensions({ height, width });
    }
  }, []);

  const imageElement = document.getElementById('zoomed-image');
  let currentZoom = 100; // Initial zoom level in percentage

  function zoomIn() {
    if (currentZoom < 200) { // Set a maximum zoom level (200% in this case)
      currentZoom += 10; // You can adjust the zoom increment
      imageElement.style.width = currentZoom + '%';
      imageElement.style.height = currentZoom + '%';
    }
  }

  function zoomOut() {
    if (currentZoom > 10) {
      currentZoom -= 10;
      imageElement.style.width = currentZoom + '%';
      imageElement.style.height = currentZoom + '%';
    }
  }
  const [currentWidth, setCurrentWidth] = useState(200);

  const [isPopupOpen, setIsPopupopen] = useState(false);
  function openPopup() {
    setIsPopupopen(true)

  }
  // Function to close the pop-up
  function closePopup() {
    setIsPopupopen(false)
  }

  const [isPopupOpens, setIsPopupopens] = useState(false);
  function openPopups() {
    setIsPopupopens(true)

  }
  // Function to close the pop-up
  function closePopups() {
    setIsPopupopens(false)
  }

  const [isPopupOpenss, setIsPopupopenss] = useState(false);
  function openPopupss() {
    setIsPopupopenss(true)

  }
  // Function to close the pop-up
  function closePopupss() {
    setIsPopupopenss(false)
  }
  const handleChange = (evt) => {
    const value = evt.target.value;
    setDataState({
      ...state,
      [evt.target.name]: value.replace(/^ +/gm, ""),
    });
  };

  return (
    <div className="pgm-details-3w">
      <div className="DetailsContainers">
        <div className="DetailsContentS pgm_details_container_s">
          <Header title="PGM Details" />
          {isLoading ? <Loader /> :
            <div className="PgmSpecialText">
              <div className="TextConatinerDetails" >
                <div className="TextContainerLeft">
                  <div>
                    <div className="Label_name_details">
                      <label>Profile Picture</label>
                    </div>
                    <div className="input_field">

                      <img alt="img" width={currentWidth} id="zoom" height="200" onClick={openPopup} src={state.profile} />
                      {isPopupOpen && (

                        <div className='popup-images'
                        >
                          <div className='zoominout'>
                          </div>
                          <img src={Image_Url.CROSSC} className='zoominoutimgcross' onClick={closePopup} />
                          <img alt="img" className='large-image' width={currentWidth} src={state.profile} />

                        </div>
                      )}

                    </div>

                  </div>
                  {state.user_name && (
                    <div>
                      <div className="Label_name_details">
                        <label>
                          PGM Name
                        </label>
                        <input type="text"
                          name="user_name"
                          className="input_field_pgmdetails"
                          value={state.user_name ? state.user_name : "undefined"}
                          readOnly />
                      </div>
                    </div>
                  )}
                  {state.mobile_number && (
                    <div>
                      <div className="Label_name_details">
                        <label>
                          Mobile Number
                        </label>
                        <input type="text"
                          name="mobile_number"
                          className="input_field_pgmdetails"
                          value={state.mobile_number}
                          readOnly />
                      </div>
                    </div>
                  )}
                  {state.email && (
                    <div>
                      <div className="Label_name_details">
                        <label>Email Id</label>
                        <input type="text"
                          name="email"
                          className="input_field_pgmdetails"
                          value={state.email ? state.email : "undefined"}
                          readOnly />
                      </div>
                    </div>
                  )}
                  {state.verification_type && (
                    <div>
                      <div className="Label_name_details">
                        <label>Verification Id Type</label>
                        <input type="text"
                          name="verification_type"
                          className="input_field_pgmdetails"
                          value={state.verification_type}
                          readOnly />
                      </div>
                    </div>
                  )}
                  {state.verification_id && (
                    <div>
                      <div className="Label_name_details">
                        <label>Verification Id</label>
                        <input type="text"
                          name=" verification_id"
                          value={state.verification_id}
                          className="input_field_pgmdetails"
                          readOnly
                        />
                      </div>
                    </div>
                  )}
                  {state.doc_file && (
                    <div>
                      <div className="Label_name_details">
                        <label>Verification Id Picture</label>
                      </div>
                      <div className="input_field">
                        <img alt="img" width={currentWidth} id="zoom" height="200" onClick={openPopups} src={state.doc_file} />
                        {isPopupOpens && (

                          <div className='popup-images'

                          >
                            <div className='zoominout'>
                            </div>
                            <img alt="img" className='large-image' width={currentWidth} src={state.doc_file} />
                            <img src={Image_Url.CROSSC} className='zoominoutimgcross' onClick={closePopups} />
                          </div>
                        )}

                      </div>
                    </div>
                  )}
                  {state.account_number && (
                    <div>
                      <div className="Label_name_details">
                        <label>PGM ID</label>
                        <input type="text"
                          name="account_number"
                          value={state.account_number}
                          className="input_field_pgmdetails"
                          readOnly />
                      </div>
                    </div>
                  )}

                  {state.gst_number && (
                    <div>
                      <div className="Label_name_details">
                        <label> GST Number</label>
                        <input type="text"
                          name="gst_number"
                          value={state?.gst_number}
                          className="input_field_pgmdetails"
                          readOnly />
                      </div>
                    </div>
                  )}

                  {state.location_link && (
                    <div>
                      <div className="Label_name_details">
                        <label>Location </label>
                        <input type="text"
                          name="agency_code"
                          value={state.location_link}
                          title={state.location_link}
                          className="input_field_pgmdetails"
                          readOnly
                        />
                      </div>
                    </div>
                  )}
                  {state.refer_code && (
                    <div>
                      <div className="Label_name_details">
                        <label>Referral Code</label>

                        <input type="text"
                          name="refer_code"
                          value={state.refer_code}
                          className="input_field_pgmdetails"
                          readOnly
                        />
                      </div>
                    </div>
                  )}
                </div>
                <div className="TextContainerRight">
                  {state.banner && (
                    <div>
                      <div className="Label_name_details">
                        <label>Shop Picture</label>
                      </div>
                      <div className="input_field">
                        <img alt="img" width={currentWidth} id="zoom" height="200" onClick={openPopupss} src={state.banner} />
                        {isPopupOpenss && (

                          <div className='popup-images'
                          >
                            <div className='zoominout'>
                            </div>
                            <img alt="img" className='large-image' width={currentWidth} src={state.banner} />
                            <img src={Image_Url.CROSSC} className='zoominoutimgcross' onClick={closePopupss} />
                          </div>
                        )}

                      </div>

                    </div>
                  )}
                  {state.shop_name && (
                    <div>
                      <div className="Label_name_details">
                        <label>Shop Name</label>

                        <input type="text"
                          name="shop_name"
                          className="input_field_pgmdetails"
                          value={state.shop_name}
                          readOnly />
                      </div>
                    </div>
                  )}
                  {state.shop_location && (
                    <div>
                      <div className="Label_name_details">
                        <label>Shop Location</label>
                        <input type="text"
                          name=" shop_location"
                          className="input_field_pgmdetails"
                          value={state.shop_location}
                          readOnly />
                      </div>
                    </div>
                  )}
                  {state?.dealers && state?.dealers?.length > 0 && (
                    <div>
                      <div className="Label_name_details">
                        <label>Dealer Name</label>
                        {state?.dealers?.map((dealer) => (
                          <input type="text"
                            name=" shop_location"
                            className="input_field_pgmdetails"
                            value={dealer?.dealer_name}
                            readOnly />
                        ))}
                      </div>
                    </div>
                  )}
                  <div>
                    <div className="Label_name_details">
                      <label>Branch Id</label>
                      <input type="text"
                        name=" shop_location"
                        className="input_field_pgmdetails"
                        readOnly />
                    </div>
                  </div>

                  {state.city && (
                    <div>
                      <div className="Label_name_details">
                        <label>City</label>
                        <input type="text"
                          name="city"
                          value={state.city ? state.city : "undefined"}
                          className="input_field_pgmdetails"
                          readOnly />
                      </div>
                    </div>
                  )}
                  {state.state && (
                    <div>
                      <div className="Label_name_details">
                        <label>State</label>
                        <input type="text"
                          name="state"
                          className="input_field_pgmdetails"
                          value={state.state ? state.state : "undefined"}
                          readOnly />
                      </div>
                    </div>
                  )}
                  {state.pincode && (
                    <div>
                      <div className="Label_name_details">
                        <label>
                          Pincode
                        </label>
                        <input type="text"
                          name="mobile_number"
                          className="input_field_pgmdetails"
                          value={state.pincode ? state.pincode : "undefined"}
                          readOnly
                        />
                      </div>
                    </div>
                  )}
                  {state.district && (
                    <div>
                      <div className="Label_name_details">
                        <label>District</label>
                        <input type="text"
                          name="district"
                          className="input_field_pgmdetails"
                          value={state.district ? state.district : "undefined"}
                          readOnly />
                      </div>
                    </div>
                  )}
                  {state.location && (
                    <div>
                      <div className="Label_name_details">
                        <label>Location</label>
                        <input type="text"
                          name="location"
                          className="input_field_pgmdetails"
                          value={state.location ? state.location : "undefined"}
                          readOnly />
                      </div>
                    </div>
                  )}
                  {/* FOR NOW IT IS COMMENTED, BUT WE CAN USE IT FOR FURTHER REQUIREMENT */}
                  {/* {state.agency_code && (
                  <div>
                    <div className="Label_name_details">
                      <label>MSR Id</label>
                      <input type="text"
                        name="agency_code"
                        value={state.agency_code}
                        className="input_field_pgmdetails"
                        readOnly
                      />
                    </div>
                  </div>
                )} */}
                </div>
              </div>
              <div className="pgmdetails_button">
                <button className="pgm-details-button3w" onClick={onclose}>Close</button>
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  );
}
export default PgmDetailsThreeWheeler;